import { render, staticRenderFns } from "./ThirdPartyTool.vue?vue&type=template&id=a8876d6c&"
import script from "./ThirdPartyTool.vue?vue&type=script&lang=ts&"
export * from "./ThirdPartyTool.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports